import { Injectable } from "@angular/core";

import { UserCredential } from "./../models/domains/pbm/user/user-credential";
import { environment } from "../../../environments/environment";
import { UserCredentials } from "../models/domains/credentials/user-credentials.model";
import { ScsAuthorizationTokenParser } from "./parsers/scs-authorizatio-token.parser";
import { RemoteGatewayFactory } from "../gateways/remote-gateway-factory";
import { UserCredentialsParser } from "./parsers/user-credentials.parser";
import { AuthUserTokenValidationUrl } from "../models/domains/urls/auth-user-token-validation.url";
import { AuthServiceTokenValidationUrl } from "../models/domains/urls/auth-service-token-validation.utl";
import { BackendUrl } from "../models/domains/urls/back-end.url";
import { UserCredentialParser } from "./parsers/pbm/user/user-credential.parser";
import { FiscalNumber } from "../models/domains/pbm/fiscal-number";
import { NetworkTermStatus } from "../models/domains/pbm/network-term/network-term-status";

@Injectable()
export class AuthRepository {
  constructor(
    private remoteGatewayFactory: RemoteGatewayFactory,
    private scsAuthorizationTokenParser: ScsAuthorizationTokenParser,
    private userCredentialsParser: UserCredentialsParser,
    private userCredentialParser: UserCredentialParser,
  ) {}

  async login(userCrendential: UserCredential) {
    const body = {
      Email: userCrendential.getEmail(),
      Password: userCrendential.getPassword(),
    };

    const headers = { "Content-Type": "application/json" };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const payload = await remoteGateway.postWithHeaders(new BackendUrl("/api/auth/user"), body, headers);

      return Promise.resolve(this.userCredentialParser.parse(payload));
      /////ver o parse para guardar o token
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  async validateUserToken(token: string): Promise<boolean> {
    return true;
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data = await remoteGateway.getWithHeaders(new AuthUserTokenValidationUrl("/Authorization/test"), headers);
      return this.scsAuthorizationTokenParser.parse(data);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  async validateServiceToken(token: string): Promise<boolean> {
    return true
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    };
    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data = await remoteGateway.getWithHeaders(new AuthServiceTokenValidationUrl("/Authorization/verify"), headers);
      return this.scsAuthorizationTokenParser.parse(data);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  async switchContext(userId: string, refreshToken: string, sourceApplicationId: string): Promise<UserCredentials> {
    try {
      const body = {
        userId,
        refreshToken,
        sourceApplicationId,
        targetApplicationId: environment.authClientId,
      };
      const gateway = this.remoteGatewayFactory.createAuthRemoteGateway();
      const data = await gateway.post("/api/switchcontext", body);
      return Promise.resolve(this.userCredentialsParser.parse(data));
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
